var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSafeHeaderLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7572 11.4983H19.2721C18.53 11.4983 17.9286 12.0769 17.9286 12.791V16.261C17.9286 16.9751 17.3272 17.5537 16.585 17.5537H6.6986C5.95641 17.5537 5.35501 18.1323 5.35501 18.8463V21.2371C5.35501 21.9512 5.95641 22.5298 6.6986 22.5298H17.1572C17.8994 22.5298 18.4922 21.9512 18.4922 21.2371V19.319C18.4922 18.6049 19.0936 18.0984 19.8358 18.0984H21.7567C22.4989 18.0984 23.1003 17.5198 23.1003 16.8058V12.776C23.1003 12.0619 22.4989 11.4983 21.7567 11.4983H21.7572Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3545 6.74865C5.3545 6.03461 5.9559 5.45602 6.6981 5.45602H16.5784C17.3206 5.45602 17.922 4.87743 17.922 4.16338V1.77259C17.922 1.05854 17.3206 0.47995 16.5784 0.47995H6.12536C5.38317 0.47995 4.78177 1.05854 4.78177 1.77259V3.61479C4.78177 4.32883 4.18037 4.90742 3.43818 4.90742H1.52587C0.783679 4.90742 0.182281 5.48601 0.182281 6.20006V10.2342C0.182281 10.9483 0.786194 11.4978 1.52839 11.4978H4.01343C4.75562 11.4978 5.35702 10.9192 5.35702 10.2052L5.3545 6.74914V6.74865Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4719 8.98514H12.8589C13.6368 8.98514 14.2679 9.59275 14.2679 10.3407V12.6371C14.2679 13.3855 13.6363 13.9927 12.8589 13.9927H10.4719C9.69402 13.9927 9.06296 13.385 9.06296 12.6371V10.3407C9.06296 9.59227 9.69453 8.98514 10.4719 8.98514V8.98514Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafeHeaderLogo);
export default __webpack_public_path__ + "static/media/safe-header-logo.7db1d0ab7071b8fb6b7c74c907a12ba3.svg";
export { ForwardRef as ReactComponent };